export default {
  global: () => {
    return {
      '#__next, #root': {
        flex: 1,
      },
      '*::placeholder': {
        color: 'muted',
        opacity: 1,
      },
      body: {
        bg: 'white',
        color: 'default',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      },
      html: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      },
    };
  },
};
